import * as React from 'react';

type Props = {
  type: string;
  color?: string;
  width?: number | string;
  height?: number | string;
  className?: string;
  onClick?: () => void;
  cursorPointer?: boolean;
};

// Tự động import toàn bộ file svg trong folder
const icons = import.meta.glob('@/assets/svg/*.svg', { eager: true, import: 'default' }) as Record<
  string,
  React.FC<React.SVGProps<SVGSVGElement>> | string
>;

// Build className từ color
const getFillClass = (color?: string) => {
  if (!color) return 'fill-current';
  if (color.startsWith('#')) return `fill-[${color}]`;
  return `fill-${color}`;
};

export const CustomIcon = ({
  type,
  color,
  width,
  height,
  className,
  onClick,
  cursorPointer,
  ...rest
}: Props) => {
  // key file SVG có dạng "@/assets/svg/user.svg"
  const iconKey = `/src/assets/svg/${type}.svg`;
  const IconComponent = icons[iconKey];

  if (!IconComponent) return null;

  // Nếu IconComponent là string (data URL), render như img
  if (typeof IconComponent === 'string') {
    return (
      <img
        src={IconComponent}
        alt={type}
        className={className || getFillClass(color)}
        width={width}
        height={height}
        onClick={onClick}
        style={{ cursor: cursorPointer ? 'pointer' : 'default' }}
      />
    );
  }

  // Nếu IconComponent là React component, render như component
  return (
    <IconComponent
      className={className || getFillClass(color)}
      width={width}
      height={height}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
      {...rest}
    />
  );
};
